<div class="m-subheader" appunwraptag="">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				ToT/ToA Dashboard
			</h3>
			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
				<li class="m-nav__item m-nav__item--home">
					<a class="m-nav__link m-nav__link--icon">
						<i class="la la-briefcase"></i>
					</a>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						Search & Apply
					</span>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						Search Batches
					</span>
				</li>
			</ul>
		</div>
	</div>
</div>

<div class="m-content">
	<div class="m-portlet m-portlet--tab">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-text title-style" *ngIf="batchDetails">
					Batch ID - {{batchDetails.batchId}}
					<!-- <button class="btn btn-secondary pull-right" data-target="#add_payment_modal" data-toggle="modal">
						Add Payment Details
					</button> -->
					<button class="btn btn-secondary pull-right" (click)="goBack()">
						Back
					</button>
				</div>
			</div>
		</div>

		<div class="m-portlet__body">
			<form class="m-form m-form--fit m-form--label-align-left" *ngIf="batchDetails">
				<!-- Batch Details -->
				<div class="m-portlet__body">
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Batch ID:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails.batchId}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Batch Name:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails.batchName}}
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Batch Type:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails.type}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Batch Date:</b>
						</label>
						<div class="col-lg-4">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails.batchStartDate | date:'dd/MM/yyyy'}} to {{batchDetails.batchEndDate | date:'dd/MM/yyyy'}}
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Sector:</b>
						</label>
						<div class="col-lg-4">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails.sector.name}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Batch Fee:</b>
						</label>
						<div class="col-lg-4">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.batchFee?.totalFees}}
							</div>
						</div>
						<!-- <label class="col-lg-2 col-form-label">
							<b>Sub-Sector:</b>
						</label>
						<div class="col-lg-4">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails.subSectors.subSectorName}}
							</div>
						</div> -->
					</div>
					<div class="form-group m-form__group row" *ngIf="batchDetails?.batchFee?.isOfferApplied">
						<label class="col-lg-2 col-form-label">
							<b>Discounted Fee Valid Till:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails?.batchFee?.discountValidTill | date: "dd-MM-yyyy"}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Discounted Batch Fee:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails?.batchFee?.feeAfterDiscount}}
						</div>
					</div>
					<!-- <div class="form-group m-form__group row">
						
					</div> -->
				</div>
				<hr>
				<!-- Training Center Details -->
				<div class="m-portlet__body">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-text title-style">
								Training Center Details
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Name of Training Center:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails?.tcDetails?.trainingCentreName ? batchDetails?.tcDetails?.trainingCentreName : 'NA'}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Training Partner:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							{{batchDetails?.tcDetails?.trainingPartner?.name ? batchDetails?.tcDetails?.trainingPartner?.name : 'NA'}}
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Mobile Number:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.spoc?.mobileNumber ? batchDetails?.tcDetails?.spoc?.mobileNumber : 'NA'}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Email ID:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.spoc?.email ? batchDetails?.tcDetails?.spoc?.email : 'NA'}}
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Center Address:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.address1 ? batchDetails?.tcDetails?.address?.address1 : 'NA'}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Nearby Landmark:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.landmark ? batchDetails?.tcDetails?.address?.landmark : 'NA'}}
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Pincode:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.pincode ? batchDetails?.tcDetails?.address?.pincode : 'NA'}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>District:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.district.name ?  batchDetails?.tcDetails?.address?.district.name : 'NA'}}
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>State/Union Territory:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.state.name ? batchDetails?.tcDetails?.address?.state.name : 'NA'}}
							</div>
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Parliamentary Constituency:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.parliamentaryConstituency?.name ? batchDetails.tcDetails.address.parliamentaryConstituency.name : "NA"}}
							</div>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>City/Tehsil/Mandal:</b>
						</label>
						<div class="col-lg-4 col-form-label">
							<div class="m-input-icon m-input-icon--right">
								{{batchDetails?.tcDetails?.address?.subDistrict?.name ? batchDetails?.tcDetails?.address?.subDistrict?.name : 'NA'}}
							</div>
						</div>
					</div>
				</div>
				<hr>
				<!-- Domain Job Role -->
				<div class="m-portlet__body">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-text title-style">
								Domain Job Role
							</div>
						</div>
					</div>
					<table class="notranslate table table-striped m-table">
						<thead class="m-datatable__head">
							<tr class="m-datatable__row">
								<th class="set-width-0">
									<b>Job Role Code</b>
								</th>
								<th class="set-width-1">
									<b>Job Role</b>
								</th>
								<th class="set-width-2" *ngIf="batchDetails.batchType != 'Reassessment'">
									<b>Training Dates</b>
								</th>
								<th class="set-width-3" *ngIf="batchDetails.batchType != 'Reassessment'">
									<b>Master Trainer Name (ID)</b>
								</th>
								<th class="set-width-4">
									<b>Assessment Dates</b>
								</th>
								<th class="set-width-5">
									<b>Assessment Agency Name (ID)</b>
								</th>
							</tr>
						</thead>
						<tbody *ngIf="batchDetails.jobRoles != undefined">
							<tr *ngFor="let job of batchDetails.jobRoles; let i = index">
								<ng-container *ngIf="!job.isPlatformQP">
									<td class="set-width-0">{{job?.qpCode}}</td>
									<td>{{job?.jobName}}</td>
									<td  *ngIf="batchDetails.batchType != 'Reassessment'">{{job?.trainingStartDate | date : "dd-MM-yyyy"}} to {{job.trainingEndDate | date : "dd-MM-yyyy"}}</td>
									<td  *ngIf="batchDetails.batchType != 'Reassessment'">
										<span *ngIf="job?.masterTrainerDetails != undefined; then thenTemplateName else elseTemplateName">
										</span>
										<ng-template #thenTemplateName>
											<span>
												{{job?.masterTrainerDetails?.name}} ({{job?.masterTrainerDetails?.userName ? job?.masterTrainerDetails?.userName : 'NA'}})
											</span>
										</ng-template>
										<ng-template #elseTemplateName>
											<span>
												N/A
											</span>
										</ng-template>
									</td>
									<td>{{job?.assessmentStartDate | date : "dd-MM-yyyy"}} to
										{{job?.assessmentEndDate | date : "dd-MM-yyyy"}}
									</td>
									<td>{{job?.assessmentAgencyDetails?.name}} ({{job?.assessmentAgencyDetails?.userName}})</td>
								</ng-container>
							</tr>
						</tbody>
					</table>
				</div>
				<hr>
				<!-- Platform Job Role -->
				<div class="m-portlet__body">
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-text title-style">
								Platform Job Role
							</div>
						</div>
					</div>
					<table class="notranslate table table-striped m-table">
						<thead class="m-datatable__head">
							<tr class="m-datatable__row">
								<th class="set-width-0">
									<b>Job Role Code</b>
								</th>
								<th class="set-width-1">
									<b>Job Role</b>
								</th>
								<th class="set-width-2" *ngIf="batchDetails.batchType != 'Reassessment'">
									<b>Training Dates</b>
								</th>
								<th class="set-width-3" *ngIf="batchDetails.batchType != 'Reassessment'">
									<b>Master Trainer Name (ID)</b>
								</th>
								<th class="set-width-4">
									<b>Assessment Dates</b>
								</th>
								<th class="set-width-5">
									<b>Assessment Agency Name (ID)</b>
								</th>
							</tr>
						</thead>
						<tbody *ngIf="batchDetails.jobRoles != undefined">
							<tr *ngFor="let job of batchDetails.jobRoles; let j = index">
								<ng-container *ngIf="job.isPlatformQP">
									<td class="set-width-0">{{job.qpCode}}</td>
									<td>{{job.jobName}}</td>
									<td *ngIf="batchDetails.batchType != 'Reassessment'">{{job?.trainingStartDate | date : "dd-MM-yyyy"}} to {{job.trainingEndDate | date : "dd-MM-yyyy"}}</td>
									<td *ngIf="batchDetails.batchType != 'Reassessment'">
										<span *ngIf="job?.masterTrainerDetails != undefined; then thenTemplateName else elseTemplateName">
										</span>
										<ng-template #thenTemplateName>
											<span>
												{{job?.masterTrainerDetails?.name}} ({{job?.masterTrainerDetails?.userName}})
											</span>
										</ng-template>
										<ng-template #elseTemplateName>
											<span>
												N/A
											</span>
										</ng-template>
									</td>
									<td>{{job?.assessmentStartDate | date : "dd-MM-yyyy"}} to
										{{job?.assessmentEndDate | date : "dd-MM-yyyy"}}
									</td>
									<td>{{job?.assessmentAgencyDetails?.name}} ({{job?.assessmentAgencyDetails?.userName}})</td>
								</ng-container>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Fee Payment Details -->
				<!-- <div class="m-portlet__body" *ngIf="userInfo.role === 'SSC'"> -->
				<div class="m-portlet__body">

					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-text title-style">
								Fee Payment Details
							</div>
						</div>
					</div>
					<div *ngIf="!(userPaymentDetails?.modeOfPayment)" style="margin-left: 30px; margin-top: 15px;">
					<h5>Payment Not Received</h5>
					</div>
					<div *ngIf="(userPaymentDetails?.modeOfPayment)">
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Mode of Payment</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.modeOfPayment}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Name of Bank</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.nameOfBank? userPaymentDetails.nameOfBank : 'N/A'}}
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Date of Payment</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.dateOfPayment | date : "dd-MM-yyyy"}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Reference No.</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.refNo}}
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-lg-2 col-form-label">
							<b>Amount</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.amount}}
						</div>
						<label class="col-lg-2 col-form-label">
							<b>Any Remarks</b>
						</label>
						<div class="col-lg-4 col-form-label">
								{{userPaymentDetails?.remarks? userPaymentDetails.remarks : "N/A"}}
						</div>
					</div>
				</div>
			</div>
			</form>
		</div>
	</div>
</div>

<!-- Add Payment Modal -->
<div class="modal fade" id="add_payment_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
 aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Enter Batch Fee Details
				</h5>
				<button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<form class="m-form" *ngIf="batchDetails" [formGroup]="batchFeeDetailsForm">
							<div class="form-group m-form__group row">
								<label class="col-lg-2 col-form-label">
									<b>Batch ID:</b>
								</label>
								<div class="col-lg-4 col-form-label">
									<div class="m-input-icon m-input-icon--right">
										{{batchDetails.batchId}}
									</div>
								</div>
								<label class="col-lg-3 col-form-label">
									<b>Batch Name:</b>
								</label>
								<div class="col-lg-3">
									<div class="m-input-icon m-input-icon--right">
										{{batchDetails.batchName}}
									</div>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-2 col-form-label">
									<b>Applicant ID:</b>
								</label>
								<div class="col-lg-4 col-form-label">
									<div class="m-input-icon m-input-icon--right">
										{{userInfo.userName}}
									</div>
								</div>
								<label class="col-lg-3 col-form-label">
									<b>Applicant Name:</b>
								</label>
								<div class="col-lg-3">
									<div class="m-input-icon m-input-icon--right">
										{{userInfo.name}}
									</div>
								</div>
							</div>
							<hr>
							<label class="form-group m-form__group"><b>Mode of Payment</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
										 enable-background="new 0 0 129 129">
											<g>
												<path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input m-input--square" formControlName="modeOfPayment">
										<option value="" selected>Select payment mode</option>
										<option *ngFor="let mop of modeOfPayement">{{mop}}</option>
									</select>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('modeOfPayment')" [name]="'Mode Of Payment'"
									 [message]="'Select mode of payment'"></app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group"><b>Bank Name</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"
										 enable-background="new 0 0 129 129">
											<g>
												<path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input m-input--square" formControlName="nameOfBank">
										<option value="" selected>Select bank</option>
										<option *ngFor="let names of bankNames">{{names}}</option>
									</select>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('nameOfBank')" [name]="'Name of Bank'" [message]="'Select name of bank'"></app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group"><b>Reference Number</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<input type="text" class="form-control m-input" formControlName="refNo" placeholder="Enter Reference Number">
									<app-form-control-messages [control]="batchFeeDetailsForm.get('refNo')" [name]="'Reference Number'" [message]="'Enter valid reference number'"></app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group"><b>Date of Payment</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<!-- <input type="date" class="form-control m-input" formControlName="dateOfPayment"> -->
									<app-date-picker [model]="dateObject" (dateChanged)="onDateChange($event)"></app-date-picker>
									<!-- <input type="text" formControlName="dateOfPayment" (blur)="dateValidation()" class="form-control" id="candidateRegistrationStartDate"
									 readonly="" placeholder="Start date" #startDate> -->
								</div>
							</div>
							<label class="form-group m-form__group"><b>Amount</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<input type="number" disabled class="form-control m-input" formControlName="amount">
									<!-- <app-form-control-messages [control]="batchFeeDetailsForm.get('amount')" [name]=" 'Amount'" [message]="'Enter amount'"></app-form-control-messages> -->
								</div>
							</div>
							<label class="form-group m-form__group"><b>Remarks</b></label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<textarea type="text" rows="5" class="form-control m-input" formControlName="remarks" placeholder="Enter Remarks"></textarea>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('remarks')" [name]="'Remarks'" [message]="'Enter remarks'"></app-form-control-messages>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!batchFeeDetailsForm.valid"
				 (click)="addPayment()">
					Submit
				</button>
				<button type="button" class="btn btn-secondary" data-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
